import { Link } from "react-router-dom";
import { renderCustomColumnDefs } from "../../../../shared/Table/table.utils";
import {
  formatDate,
  renderAmount,
} from "../../../../utils";

// Config for Payout report UI table
const tableConfig = [
  {
    id: "payoutId",
    header: "Payout",
    minWidth: 120,
    cell: ({ getValue, row }) => {
      const value = getValue();
      const rowId = row.original._id;
      if (rowId) {
        return (
          <Link
            to={`/payouts/${rowId}`}
            className="text-primary-600 hover:underline cursor-pointer"
          >
            {value || rowId}
          </Link>
        );
      }
      return value || "-";
    },
  },
  {
    id: "payDate",
    header: "Pay Date",
    minWidth: 120,
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return "-";
      return formatDate(value);
    },
  },
  {
    id: "mileageRate",
    header: "Mileage Rate",
    minWidth: 120,
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "emptyRate",
    header: "Empty Rate",
    minWidth: 120,
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "hourlyRate",
    header: "Hourly Rate",
    minWidth: 120,
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "totalMileage",
    header: "Total Miles",
    minWidth: 120,
    cell: ({ getValue }) => {
      const value = getValue();
      if (value === null || value === undefined) return "-";
      return `${value.toLocaleString()} mi`;
    },
  },
  {
    id: "mileageTotal",
    header: "Mileage Total",
    minWidth: 130,
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "supplementalTotal",
    header: "Supplemental Total",
    minWidth: 150,
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "total",
    header: "Gross",
    minWidth: 120,
    cell: ({ getValue }) => renderAmount(getValue()),
  },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);














